import React = require('react');

import ErrorIcon from "material-ui/svg-icons/alert/error";

import l10n from 'diy/util/l10n';

interface ErrorViewProps extends React.Props<ErrorView> {
    supportHandler: Function;
}

export default class ErrorView extends React.Component<ErrorViewProps, any> {
    componentDidMount() {
        let dialogHtml = this.refs["transferDialogHtml"] as HTMLElement;
        let supportLink =
            dialogHtml.getElementsByClassName("transfer-dialog-error-description-link")[0] as HTMLAnchorElement;

        if (supportLink) {
            supportLink.onclick = (event: Event) => {
                event.preventDefault();
                this.props.supportHandler();
            };
        }
    }

    render() {
        return (
            <div ref="transferDialogHtml">
                <div className="transfer-dialog-container">
                    <div className="transfer-dialog-error-icon">
                        <ErrorIcon color="#ff0000" />
                    </div>
                    <h3 className="transfer-dialog-error-title">
                        {l10n("migration.transfer.error.title")}
                    </h3>
                    <div className="transfer-dialog-description" dangerouslySetInnerHTML={{__html:
                        l10n("migration.transfer.error.description").replace(
                            "{supportLink}",
                            `<a href="#" class="transfer-dialog-error-description-link">
                                ${l10n("migration.error.supportLink")}
                            </a>`
                        )
                    }}>
                    </div>
                    <div className="transfer-dialog-error-button">

                    </div>
                </div>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/externalwebsiteimport/transferDialog/views/ErrorView.tsx
 **/